import React from 'react'

import DynamicHeaderButtonContainer from './DynamicHeaderButton.container'

const DynamicHeaderComponent = ({ multiselect, headerButtons, env, api, selectedRows, analytics }) => {
  return headerButtons.buttons.map((headerAction, i) => {
    const minimumSelected = (multiselect && headerAction.minimumSelected) ? headerAction.minimumSelected : 0

    return (
      <DynamicHeaderButtonContainer analytics={analytics} selectedRows={selectedRows} key={'dynamicbutton_' + i} minimumSelected={minimumSelected} label={headerAction.label} callback={headerAction.callback} icon={headerAction.icon} env={env} api={api} />
    )
  })
}

export default DynamicHeaderComponent
